import { Routes } from '@angular/router';
import { studentAuthGuard } from './guards/student-auth.guard';
import { parentAuthGuard } from './guards/parent-auth.guard';
import { teacherAuthGuard } from './guards/teacher-auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home').then(m => m.HomeComponent)
  },
  {
    path: 'ResetPassword',
    loadComponent: () =>
      import('./pages/reset-password/reset-password')
        .then(c => c.ResetPassword)
  },
  {
    path: 'Account/ParentRegister',
    loadComponent: () =>
      import('./Account/parent-register/parent-register')
        .then(m => m.ParentRegisterComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then(m => m.LoginComponent)
  },
  {
    path: 'login-teacher',
    loadComponent: () => import('./pages/login-teacher/login-teacher').then(m => m.LoginTeacherComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/forgot-password/forgot-password').then(m => m.ForgotPassword)
  },
  {
    path: 'logout',
    loadComponent: () => import('./pages/logout/logout').then(m => m.LogoutComponent)
  },
  {
    path: 'teacher',
    loadComponent: () => import('./pages/teacher/teacher').then(m => m.TeacherComponent)
  },
  {
    path: 'contact',
    loadComponent: () => import('./pages/contact-us/contact-us').then(m => m.ContactUsComponent)
  },
  {
    path: 'registration',
    loadComponent: () => import('./pages/registration/registration').then(m => m.RegisterComponent)
  },
  {
    path: 'single-course/:courseId',
    loadComponent: () =>
      import('./pages/single-course/single-course').then(m => m.SingleCourseComponent)
  },
  {
    path: 'course-batches/:courseId',
    loadComponent: () =>
      import('./pages/course-batches/course-batches').then(m => m.CourseBatchesComponent)
  },
  {
    path: 'coursesummary',
    loadComponent: () =>
      import('./pages/coursesummary/coursesummary').then(m => m.CourseSummaryComponent)
  },
  {
  path: 'about',
  loadComponent: () => import('./pages/about/about').then(m => m.AboutComponent)
},
  // Subjects
{
  path: 'subjects/maths',
  loadComponent: () => import('./pages/subjects/maths/maths').then(m => m.MathsComponent)
},
{
  path: 'subjects/maths/arithmetic',
  loadComponent: () =>
    import('./pages/subjects/maths/arithmetic/arithmetic')
      .then(m => m.ArithmeticComponent)
},
{
  path: 'subjects/maths/algebra',
  loadComponent: () =>
    import('./pages/subjects/maths/algebra/algebra')
      .then(m => m.AlgebraComponent)
},
{
  path: 'subjects/maths/geometry',
  loadComponent: () =>
    import('./pages/subjects/maths/geometry/geometry')
      .then(m => m.GeometryComponent)
},
{
  path: 'subjects/maths/trigonometry',
  loadComponent: () =>
    import('./pages/subjects/maths/trigonometry/trigonometry')
      .then(m => m.TrigonometryComponent)
},
{
  path: 'subjects/maths/statistics',
  loadComponent: () =>
    import('./pages/subjects/maths/statistics/statistics')
      .then(m => m.StatisticsComponent)
},
{
  path: 'subjects/english/grammar',
  loadComponent: () =>
    import('./pages/subjects/english/grammar/grammar')
      .then(m => m.GrammarComponent)
},
{
  path: 'subjects/english/reading',
  loadComponent: () =>
    import('./pages/subjects/english/reading/reading')
      .then(m => m.ReadingComponent)
},
{
  path: 'subjects/history/ancient',
  loadComponent: () =>
    import('./pages/subjects/history/ancient/ancient')
      .then(m => m.AncientComponent)
},
{
  path: 'subjects/history/modernhistory',
  loadComponent: () =>
    import('./pages/subjects/history/modern-histroy/modern-history')
      .then(m => m.ModernHistoryComponent)
},
{
  path: 'subjects/science/biology',
  loadComponent: () =>
    import('./pages/subjects/science/biology/biology')
      .then(m => m.biologyComponent)
},
{
  path: 'subjects/science/chemistry',
  loadComponent: () =>
    import('./pages/subjects/science/chemistry/chemistry')
      .then(m => m.chemistryComponent)
},
{
  path: 'subjects/science/physics',
  loadComponent: () =>
    import('./pages/subjects/science/physics/physics')
      .then(m => m.PhysicsComponent)
},
{
  path: 'subjects/science',
  loadComponent: () => import('./pages/subjects/science/science').then(m => m.ScienceComponent)
},
{
  path: 'subjects/english',
  loadComponent: () => import('./pages/subjects/english/english').then(m => m.EnglishComponent)
},
{
  path: 'subjects/history',
  loadComponent: () => import('./pages/subjects/history/history').then(m => m.HistoryComponent)
},

// Languages
{
  path: 'languages/marathi',
  loadComponent: () => import('./pages/languages/marathi/marathi').then(m => m.MarathiComponent)
},
{
  path: 'languages/hindi',
  loadComponent: () => import('./pages/languages/hindi/hindi').then(m => m.HindiComponent)
},
{
  path: 'languages/sanskrit',
  loadComponent: () => import('./pages/languages/sanskrit/sanskrit').then(m => m.SanskritComponent)
},
{
  path: 'languages/german',
  loadComponent: () => import('./pages/languages/german/german').then(m => m.GermanComponent)
},
//classes
{
  path: 'Class/Class1_5',
  loadComponent: () => import('./pages/classes/class1-5/class1-5').then(m => m.Class15Component)
},
{
  path: 'Class/Class6_8',
  loadComponent: () => import('./pages/classes/class6-8/class6-8').then(m => m.Class68Component)
},
{
  path: 'Class/Class9_10',
  loadComponent: () => import('./pages/classes/class9-10/class9-10').then(m => m.Class910Component)
},
{
  path: 'Class/Class11_12',
  loadComponent: () => import('./pages/classes/class11-12/class11-12').then(m => m.Class1112Component)
},
{
  path: 'class/class1',
  loadComponent: () => import('./pages/class/class1/class1').then(m=>m.ClassPageComponent)
},
{
  path: 'class/class2',
  loadComponent: () => import('./pages/class/class2/class2').then(m=>m.Class2)
},
{
  path: 'class/class3',
  loadComponent: () => import('./pages/class/class3/class3').then(m=>m.Class3)
},
{
  path: 'class/class4',
  loadComponent: () => import('./pages/class/class4/class4').then(m=>m.Class4)
},
{
  path: 'class/class5',
  loadComponent: () => import('./pages/class/class5/class5').then(m=>m.Class5)
},
{
  path: 'class/class6',
  loadComponent: () => import('./pages/class/class6/class6').then(m=>m.Class6)
},
{
  path: 'class/class7',
  loadComponent: () => import('./pages/class/class7/class7').then(m=>m.Class7)
},
{
  path: 'class/class8',
  loadComponent: () => import('./pages/class/class8/class8').then(m=>m.Class8)
},
{
  path: 'class/class9',
  loadComponent: () => import('./pages/class/class9/class9').then(m=>m.Class9)
},
{
  path: 'class/class10',
  loadComponent: () => import('./pages/class/class10/class10').then(m=>m.Class10)
},
{
  path: 'class/class11',
  loadComponent: () => import('./pages/class/class11/class11').then(m=>m.Class11)
},
{
  path: 'class/class12',
  loadComponent: () => import('./pages/class/class12/class12').then(m=>m.Class12)
},
  {
    path: 'student',
    canActivate: [studentAuthGuard],
    loadComponent: () => import('./studentpanel/studlayout/studlayout')
      .then(m => m.StudLayoutComponent),
    children: [
      { path: '', redirectTo: 'account', pathMatch: 'full' },
      {
        path: 'account',
        loadComponent: () => import('./studentpanel/accountdetails/accountdetails')
          .then(m => m.AccountdetailsComponent)
      },
      // Aliases → remove these once real routes are added
      { path: 'accountdetails', redirectTo: 'account', pathMatch: 'full' },

      // Uncomment below and remove the redirect when UpdateProfileComponent is ready
      {
        path: 'profile',
        loadComponent: () => import('./studentpanel/updateprofile/updateprofile')
          .then(m => m.UpdateProfileComponent)
      },
      { path: 'updateprofile', redirectTo: 'profile', pathMatch: 'full' },
      {
        path: 'inviteparent',
        loadComponent: () => import('./studentpanel/inviteparent/inviteparent')
          .then(m => m.InviteParentComponent)
      },

      {
        path: 'calendar',
        loadComponent: () => import('./studentpanel/calendar/calendar')
          .then(m => m.CalendarComponent)
      },

      {
        path: 'manageaccount',
        loadComponent: () => import('./studentpanel/manageaccount/manageaccount')
          .then(m => m.ManageAccountComponent)
      },

      {
        path: 'security',
        loadComponent: () => import('./studentpanel/comingsoon/comingsoon')
          .then(m => m.ComingSoonComponent),
        data: { title: 'Security' }
      },
      {
        path: 'notifications',
        loadComponent: () => import('./studentpanel/notifications/notifications')
          .then(m => m.Notifications),
        data: { title: 'Notifications' }
      },
      {
        path: 'inbox',
        loadComponent: () => import('./studentpanel/studinbox/studinbox')
          .then(m => m.StudentInbox),
        data: { title: 'Messages' }
      },
      {
        path: 'saved-items',
        loadComponent: () => import('./studentpanel/saved-items/saved-items')
          .then(m => m.SavedItems),
        data: { title: 'Saved Items' }
      },
      {
        path: 'my-collections',
        loadComponent: () => import('./studentpanel/my-collection/my-collection')
          .then(m => m.MyCollectionComponent),
        data: { title: 'My Collections' }
      },
      {
        path: 'payment-details',
        loadComponent: () => import('./studentpanel/paymentdetails/paymentdetails')
          .then(m => m.PaymentDetailsComponent),
        data: { title: 'Payment Details' }
      },
      {
        path: 'help',
        loadComponent: () => import('./studentpanel/help/help')
          .then(m => m.HelpComponent)
      }
    ]
  },
  {
    path: 'ParentPanel',
    canActivate: [parentAuthGuard],
    loadComponent: () => import('./parentpanel/parentlayout/parentlayout')
      .then(m => m.ParentLayoutComponent),
    children: [
      { path: '', redirectTo: 'Academic/Performance', pathMatch: 'full' },
      {
        path: 'Academic/Performance',
        loadComponent: () => import('./parentpanel/performance/performance')
          .then(m => m.PerformanceComponent)
      },
      {
        path: 'Academic/Subjects',
        loadComponent: () => import('./parentpanel/subjectcourses/subjectcourses')
          .then(m => m.SubjectcoursesComponent)
      },
      {
        path: 'Academic/Tutors',
        loadComponent: () => import('./parentpanel/tutors/tutors')
          .then(m => m.TutorsComponent)
      },
      {
        path: 'Activity/Attendance',
        loadComponent: () => import('./parentpanel/attendance/attendance')
          .then(m => m.AttendanceComponent)
      },
      {
        path: 'Activity/Assignments',
        loadComponent: () => import('./parentpanel/assignments/assignments')
          .then(m => m.AssignmentsComponent)
      },
      {
        path: 'Activity/ReportCards',
        loadComponent: () => import('./parentpanel/reportcards/reportcards')
          .then(m => m.ReportCardsComponent)
      },
      {
        path: 'Payments/Overview',
        loadComponent: () => import('./parentpanel/payments/payments')
          .then(m => m.PaymentsComponent)
      },
      // {
      //   path: 'Payments/History',
      //   loadComponent: () => import('./parentpanel/payment-history/payment-history')
      //     .then(m => m.PaymentHistoryComponent)
      // },
      {
        path: 'Payments/Coupons',
        loadComponent: () => import('./parentpanel/coupons/coupons')
          .then(m => m.CouponsComponent)
      },
      {
        path: 'MyProfile',
        loadComponent: () => import('./parentpanel/myprofile/myprofile')
          .then(m => m.MyprofileComponent)
      }
    ]
  },
  {
    path: 'TeacherPanel',
    canActivate: [teacherAuthGuard],
    loadComponent: () => import('./teacherpanel/teachlayout/teachlayout')
      .then(m => m.TeachLayoutComponent),
    children: [
      { path: '', redirectTo: 'teachhome', pathMatch: 'full' },
      {
        path: 'teachhome',
        loadComponent: () => import('./teacherpanel/teachhome/teachhome')
          .then(m => m.TeachHomeComponent)
      },
      { path: 'Profile', redirectTo: 'Profile/BasicInfo', pathMatch: 'full' },
      { path: 'profile', redirectTo: 'Profile/BasicInfo', pathMatch: 'full' },
      {
      path: 'Profile/BasicInfo',
      loadComponent: () => import('./teacherpanel/profile/basic-info/basic-info')
        .then(m => m.BasicInfoComponent)
      },
      {
        path: 'Profile/Education',
        loadComponent: () => import('./teacherpanel/profile/education/education')
          .then(m => m.EducationComponent)
      },
      {
        path: 'Profile/Experience',
        loadComponent: () => import('./teacherpanel/profile/experience/experience')
          .then(m => m.ExperienceComponent)
      },
      {
        path: 'Profile/ProfessionalSummary',
        loadComponent: () => import('./teacherpanel/profile/professional-summary/professional-summary')
          .then(m => m.ProfessionalSummaryComponent)
      },
      {
        path: 'Courses/CreateCourses',
        loadComponent: () => import('./teacherpanel/courses/createcourse/createcourse')
          .then(m => m.CreateCourseComponent)
      },
      {
        path: 'Courses/CoursesList',
        loadComponent: () => import('./teacherpanel/courses/courseslist/courseslist')
          .then(m => m.CourseslistComponent)
      },
      {
       path: 'Courses/ModifyCourse',
       loadComponent: () => import('./teacherpanel/courses/modifycourse/modifycourse')
          .then(m => m.ModifyCourseComponent)
      },
      {
        path: 'Batches/CreateBatch',
        loadComponent: () => import('./teacherpanel/batches/createbatch/createbatch')
          .then(m => m.CreateBatchComponent)
      },
      {
        path: 'Batches/BatchList',
        loadComponent: () =>
          import('./teacherpanel/batches/batchlist/batchlist')
          .then(m => m.BatchlistComponent)
      },
      {
        path: 'Batches/ModifyBatch',
        loadComponent: ()=> import('./teacherpanel/batches/modifybatch/modifybatch')
          .then(m=> m.ModifyBatchComponent)
      },
      {
        path: 'Dashboard/Calendar',
        loadComponent: ()=> import('./teacherpanel/dashboard/calendar/calendar')
          .then(m=>m.CalendarComponent)
      },
      // ── Coming Soon routes ──
      {
        path: 'Enrolments/Course',
        loadComponent: () => import('./teacherpanel/enrolments/course-wise/course-wise')
          .then(m => m.CourseWiseEnrollmentsComponent)
      },
      {
        path: 'Enrolments/Batch',
        loadComponent: () => import('./teacherpanel/enrolments/batch-wise/batch-wise')
          .then(m => m.BatchWise)
      },
      {
        path: 'Inbox/Mailbox',
        loadComponent: () => import('./teacherpanel/inbox/inbox')
          .then(m => m.Inbox)
      },
      {
        path: 'Dashboard/Chat',
        loadComponent: () => import('./teacherpanel/comingsoon/comingsoon')
          .then(m => m.ComingSoonComponent)
      },
      {
        path: 'Dashboard/Support',
        loadComponent: () => import('./teacherpanel/dashboard/support-ticket/support-ticket')
          .then(m => m.TeacherSupportTicket)
      },
      {
        path: 'Dashboard/Contacts',
        loadComponent: () => import('./teacherpanel/comingsoon/comingsoon')
          .then(m => m.ComingSoonComponent)
      },
      {
        path: 'Dashboard/ContactDetail',
        loadComponent: () => import('./teacherpanel/comingsoon/comingsoon')
          .then(m => m.ComingSoonComponent)
      },
      {
        path: 'Reviews',
        loadComponent: () => import('./teacherpanel/reviews/reviews')
          .then(m => m.ReviewsComponent)
      },
      {
        path: 'Income',
        loadComponent: () => import('./teacherpanel/income/income')
          .then(m => m.Income)
      },
      {
        path: 'MyProfile',
        loadComponent: () => import('./teacherpanel/myprofile/myprofile')
          .then(m => m.MyProfileComponent)
      }
    ]
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/page-not-found/page-not-found')
        .then(m => m.PageNotFound),
    data: { hideGlobalChrome: true }
  }
];
